<p-dialog
    appDialogoPadrao="pi pi-exclamation-triangle"
    descricao="Registro em destaque na ata."
    closeAriaLabel="Fechar"
    header="Importante"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: '520px', border: 'none' }"
    styleClass="dialogo-importante-custom"
    appendTo="body"
    (onHide)="fechar()"
>
    <div class="flex flex-col gap-2 py-2 px-1">
        <label for="textoImportanteAta" class="text-sm font-semibold text-color">Texto importante</label>
        <textarea id="textoImportanteAta" pInputText [ngModel]="texto()" (ngModelChange)="texto.set($event)" rows="6" class="w-full texto-importante-ata" placeholder="Informe o texto que deve ficar associado a esta ata"></textarea>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
            <button type="button" pButton label="Confirmar" severity="primary" [appCan]="roleAtasEditar" (click)="aoConfirmar()"></button>
        </div>
    </ng-template>
</p-dialog>
